<template>
  <div class="confirmation-uploading">
    <div class="batch-upload-step-third">
      <div class="step-third-circle">
        <img class="img-circle" src="@/assets/image/batch-upload-dialog/ic_circle.png">
        <img class="img-circle-center" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
        <span class="span-progress">{{ `${matchProgress ? matchProgress.toFixed(2) : 0}%` }}</span>
      </div>
      <div class="step-third-tip" style="height: 24px;"></div>
      <div class="step-third-btn">
        <button class="btn-cancel" @click.stop="clickCancel">取消</button>
        <button class="btn-small" @click.stop="clickSmall">最小化</button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import {confirmationImportProgress} from '@/assets/js/api';

export default {
  name: 'confirmation-uploading',
  props: {
    matchProgress: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {interval: null};
  },
  computed: {...mapState({confirmationExport: state => state.longTask.confirmationExport})},
  created() {
    this.interval = setInterval(() => {
      confirmationImportProgress({bizNo: this.confirmationExport.id}).then(({
        code, data
      }) => {
        if (code === 200 && data) {
          if (data.code !== 202) {
            this.$emit('uploadProgress', 200);
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'status',
              value: 3
            });
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'details',
              value: data.details || []
            });
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'url',
              value: data.url || ''
            });
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'code',
              value: data.code || ''
            });
            this.$store.commit('SET_CONFIRMATION_EXPORT', {
              key: 'msg',
              value: data.msg || ''
            });
          }
        } else {
          this.$emit('uploadProgress', 200);
          this.$store.commit('SET_CONFIRMATION_EXPORT', {
            key: 'status',
            value: 3
          });
        }
      });
    }, 1500);
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel');
    },
    clickSmall() {
      this.$emit('clickSmall');
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }

};
</script>

<style lang="scss" rel="stylesheet/scss">

</style>
